import { render, staticRenderFns } from "./GenerateView.vue?vue&type=template&id=c24da61c&scoped=true&"
import script from "./GenerateView.vue?vue&type=script&lang=js&"
export * from "./GenerateView.vue?vue&type=script&lang=js&"
import style0 from "./GenerateView.vue?vue&type=style&index=0&id=c24da61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24da61c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VContainer})
